import store from '@/store/store'

import AddressService from '@/services/retailer/AddressService.js'

import { errorMessage } from '@/utilities/helpers'

import { ADDRESS_ERROR_MESSAGES } from '@/constants/errorMessages'

export const addressMixin = {
  data() {
    return {
      cities: [],
      counties: [],
      neighborhoods: [],
      cityIsLoading: false,
      countyIsLoading: false,
      neighborhoodIsLoading: false,
      city: null,
      county: null,
      district: null,
      neighborhood: null
    }
  },
  methods: {
    getCities() {
      this.cityIsLoading = true
      this.county = null
      this.district = null
      this.neighborhood = null
      this.counties = []
      this.districts = []
      this.neighborhoods = []

      AddressService.getCities()
        .then(response => {
          this.cityIsLoading = false
          this.cities = response.data
        })
        .catch(err => {
          const notifications = {
            type: 'danger',
            message: ADDRESS_ERROR_MESSAGES.getCitiesError + errorMessage(err)
          }
          store.dispatch('notification/add', notifications, {
            root: true
          })
        })
    },
    getCounties(city) {
      this.countyIsLoading = true
      this.districts = []
      this.neighborhoods = []
      this.county = null
      this.district = null
      this.neighborhood = null

      AddressService.getCounties(city.id)
        .then(response => {
          this.countyIsLoading = false
          this.counties = response.data
        })
        .catch(err => {
          const notifications = {
            type: 'danger',
            message: ADDRESS_ERROR_MESSAGES.getCountiesError + errorMessage(err)
          }
          store.dispatch('notification/add', notifications, {
            root: true
          })
        })
    },
    getNeighborhoods(county) {
      this.neighborhoodIsLoading = true

      AddressService.getNeighborhoods(county.id)
        .then(response => {
          this.neighborhoodIsLoading = false
          this.neighborhoods = response.data
        })
        .catch(err => {
          const notifications = {
            type: 'danger',
            message: ADDRESS_ERROR_MESSAGES.getNeighborhoodsError + errorMessage(err)
          }
          store.dispatch('notification/add', notifications, {
            root: true
          })
        })
    }
  }
}
